import React, { useState } from 'react';
import './FindTheError.scss';
import Tabs from './partials/Tabs/Tabs';
import Button from '../../partials/Button';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

const FindTheError = props => {
  const data = props.data;
  const [source, setSource] = useState(() => {
    return {
      ...data,
      tabs: data.tabs.map(t => {
        return {
          ...t,
          sections: t.hasOwnProperty('sections') ? t.sections.map(s => {
            return {
              ...s,
              completed: false,
              actions: s.actions.map(a => {
                return {
                  ...a,
                  clicked: false
                }
              })
            }
          }) : []
        }
      })
    }
  })
  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(0);

  const nextTab = () => {
    let newData = source;

    if (tab < newData.tabs.length) {
      newData.tabs[tab].completed = true;
      newData.tabs[tab].active = false;
      newData.tabs[tab + 1].active = true;
      newData.tabs[tab + 1].locked = false;

      setSource({
        ...source,
        tabs: newData.tabs
      });
      setTab(tab + 1);
    }

  }

  const changeTab = (tab) => {
    if (source.tabs[tab].locked) {
      return;
    }
    setTab(tab);
  };

  const changePage = (page) => setPage(page);

  const prevPage = () => setPage(page - 1);

  const nextPage = () => setPage(page + 1);

  const changeActionVisibility = (tab, section, action) => {

    let newData = source;
    let actions = newData.tabs[tab].sections[section].actions;
    // First we hide all other actions
    actions.forEach((item, index) => {
      if (index !== action) {
        item.active = false;
      } else {
        item.active = !item.active;
        item.clicked = true;
      }
    });

    setSource({
      ...source,
      tabs: newData.tabs
    });
  }

  // This function is for retry the whole interaction from the beggining
  const retryQuiz = () => {
    setSource({
      ...source,
      tabs: data.tabs
    });
  }

  return (
    <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
      <div className="find-the-error">
        <div className="back-btn-container">
          <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
        </div>
        <Tabs
          data={source}
          page={page}
          currentTab={tab}
          nextTab={nextTab}
          changeTab={changeTab}
          prevPage={prevPage}
          nextPage={nextPage}
          changePage={changePage}
          changeActionVisibility={changeActionVisibility}
          retryQuiz={retryQuiz}
          onComplete={props.onComplete}
        />
      </div>
    </InteractionContainer>
  );
}

export default FindTheError;